import i18n from '@/shared/i18n';
import init from '@/shared/init';
import store from '@/shared/store';
import router from './router';
import layouts from './layouts';
import plugins from './plugins';

store.commit('platform/SET_EMBEDDED_PLAYER');

init({ layouts, options: { i18n, router, store }, plugins });
